<template>
  <div></div>
</template>

<script>
import JSZip from 'jszip'
import {saveAs} from 'file-saver'

export default {
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    event () {
      return this.adminData.event
    }
  },
  methods: {
    convertToCSV (objArray, headers) {
      var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray

      this.csvStr = this.createHeaderString(headers)

      for (var i = 0; i < array.length; i++) {
        var line = ''
        var object = this.flattenObject(array[i])

        headers.forEach(h => {
          if (line !== '') line += ','
          line += object[h.field] ? `"${object[h.field]}"` : '""'
        })

        this.csvStr += line + '\r\n'
      }
      return this.csvStr
    },
    exportCSVFile (fileTitle, objArray, headers, headerRow, email = false) {
      let csvData = this.convertToCSV(objArray, headers)
      if (headerRow) {
        csvData = headerRow + '\n' + csvData
      }
      var toDownload = [{
        csv: csvData,
        fileName: fileTitle + '.csv' || 'export.csv'
      }]

      toDownload.forEach(d => {
        var blob = new Blob([d.csv], {type: 'text/csv;charset=utf-8;'})
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, d.fileName)
        } else {
          var link = document.createElement('a')
          if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', d.fileName)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }
      })
    },
    exportZipFile (zipTitle, data, headers, email = false) {
      var zip = new JSZip()
      data.forEach((item, i) => {
        var csvData = this.convertToCSV(item.data, headers)
        if (item.headerRow) {
          csvData = item.headerRow + '\n' + csvData
        }
        zip.file(item.fileName + '.csv', csvData)
      })
      zip.generateAsync({type: 'blob'}).then((content) => {
        // see FileSaver.js
        saveAs(content, zipTitle + '.zip')
      })
    },
    emailData (data, headers, btrjla_results = false) {
      let files = []
      data.forEach((item, i) => {
        let csvData = this.convertToCSV(item.data, headers)
        if (item.headerRow) {
          csvData = item.headerRow + '\n' + csvData
        }
        let file = {
          Name: item.fileName + '.csv',
          Content: csvData,
          ContentType: 'text/csv'
        }
        files.push(file)
      })
      return this.$store.state.apiInstance.post('/results/emailResults', {
        files: files,
        replyToEmail: this.adminData.show_admin.email,
        contact: this.adminData.show_admin.first_name + ' ' + this.adminData.show_admin.last_name,
        event_identifier: this.event.event_identifier,
        event_name: this.event.name,
        btrjla_results: btrjla_results
      })
    },
    flattenObject (object) {
      var toReturn = {}

      for (var i in object) {
        if (!object.hasOwnProperty(i)) continue

        if (typeof object[i] === 'object') {
          var flatObject = this.flattenObject(object[i])

          for (var x in flatObject) {
            if (!flatObject.hasOwnProperty(x)) continue
            toReturn[i + '.' + x] = flatObject[x]
          }
        } else {
          toReturn[i] = object[i]
        }
      }
      return toReturn
    },
    createHeaderString (headers) {
      var headerStr = ''
      headers.forEach(h => {
        headerStr += h.header + ','
      })
      headerStr += '\r\n'
      return headerStr
    }
  }
}
</script>

<style>

</style>
